import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Stack,
  Typography,
  CircularProgress,
  IconButton,
  Slider,
  Tooltip,
  Button,
  Tabs,
  Tab,
} from "@mui/material";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { ZoomIn, ZoomOut, Print } from "@mui/icons-material";
import { useContext, useEffect, useState, useRef } from "react";
import typeScriptContext from "../../../../AppState/SystemConfig/appContext";
import { PictureAsPdf, Image } from "@mui/icons-material";
import { BrowserView, MobileView, isBrowser } from "react-device-detect";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useLayoutEffect } from "react";


const translate = [
  {
    language: "es",
    labels: {
      documento: "Documento",
      txt_Documents: "Documentos",
      txt_Estudio: "Estudio",
      lbl_Paciente: "Paciente",
      txt_selectDocument: "Selecciona un documento para visualizarlo.",
      txt_noDocuments: "No hay documentos disponibles.",
      cargando: "Cargando documento…",
      descargar: "Descargar archivo",
      txt_noPreview:"Este tipo de archivo no se puede previsualizar.",
      imprimir: "Imprimir",
      tipo_pdf: "Tipo PDF",
      tipo_imagen: "Tipo Imagen",
      tipo_archivo: "Tipo Archivo",
      error_loading_document: "Error al cargar el documento.",
      txt_noPreview_mobile:"No es posible previsualizar este tipo de archivo en móvil."
      
      
    },
  },
  {
    language: "en",
    labels: {
      documento: "Document",
      txt_Documents: "Documents",
      txt_Estudio: "Study",
      lbl_Paciente: "Patient",
      txt_selectDocument: "Select a document to view it.",
      txt_noDocuments: "No documents available.",
      cargando: "Loading document…",
      descargar: "Download file",
      txt_noPreview:"This type of file cannot be previewed.",
      imprimir: "Print",
      tipo_pdf: "PDF Type",
      tipo_imagen: "Image Type",
      tipo_archivo: "File Type",
      error_loading_document: "Error loading document.",
      txt_noPreview_mobile:"It is not possible to preview this type of file on mobile."
    },
  },
];

export default function DocumentosByEstudioDialog({ open, closeModal, selectedUrl, folio }) {
  const { AppManager } = useContext(typeScriptContext);

  const [listaDocs, setListaDocs] = useState([]);
  const [listaDocsPatient, setListaDocsPatient] = useState([]);
  const [rowSelected, setRowSelected] = useState(null);
  const [doc, setDoc] = useState({ url: null, isPdf: false, isImage: false, isDownloadOnly: false, name: "" });
  const [fileType, setFileType] = useState(null);
  const [tabSelected, setTabSelected] = useState("estudio");
  const [totalPages, setTotalPages] = useState(1);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [errorPdf, setErrorPdf] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const dragStart = useRef({ x: 0, y: 0 });
  const lastPos = useRef({ x: 0, y: 0 });

  const startDrag = (e) => {
    e.preventDefault();
    setDragging(true);
    const { clientX, clientY } = e.touches?.[0] ?? e;
    dragStart.current = { x: clientX, y: clientY };
    lastPos.current = pos;
  };
  const duringDrag = (e) => {
    if (!dragging) return;
    const { clientX, clientY } = e.touches?.[0] ?? e;
    setPos({
      x: lastPos.current.x + (clientX - dragStart.current.x),
      y: lastPos.current.y + (clientY - dragStart.current.y),
    });
  };
  const endDrag = () => setDragging(false);

  const handlePrint = () => {
    if (!doc.url) return;
    const w = window.open("", "_blank", "width=1350,height=950");
    w.document.write(`
      <html><head><title>Print</title>
      <style>html,body{margin:0;height:100%}</style></head><body>
        ${
          doc.isPdf
            ? `<iframe src="${doc.url}" style="border:0;width:100%;height:100%"></iframe>`
            : `<img src="${doc.url}" style="max-width:100%;max-height:100%"/>`
        }
      </body></html>`);
    w.document.close();
    w.onload = () => {
      w.print();
      w.close();
    };
  };

  prompt.setDocumentosByEstudio = (arr) => setListaDocs((p) => [...arr, ...p]);
  prompt.setDocumentosByPaciente = (arr) => setListaDocsPatient((p) => [...arr, ...p]);

  prompt.setDocumentoRecibido = (payload) => {
    const current = [...listaDocs, ...listaDocsPatient].find((d) => d.IdDocumento === rowSelected);
    const name = current?.Nombre?.toLowerCase() || "";
    const isPdf = name.endsWith(".pdf");
    const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/.test(name);
    const isDownloadOnly = !isPdf && !isImage;

    const url = payload?.url;

    setDoc({ url, isPdf, isImage, isDownloadOnly, name });
  };

  //Carga los documentos de estudio y paciente
  useEffect(() => {
    if (
      listaDocs.length === 0 &&
      listaDocsPatient.length === 0 &&
      !AppManager.isLoadingDocumentos &&
      !AppManager.isLoadingDocumentosPatient
    ) {
      AppManager.loadDocumentosByEstudio(prompt, folio);
      if (AppManager.profileData) {
        AppManager.loadDocumentosByPatient(prompt, AppManager.profileData.Id);
      }
    }
  }, [AppManager, listaDocs.length, listaDocsPatient.length, AppManager.profileData, folio]);

  useEffect(() => {
    if (isBrowser && (listaDocsPatient.length || listaDocs.length) && !rowSelected) {
      const latest = [...listaDocs, ...listaDocsPatient].sort((a, b) => +new Date(b.Fecha) - +new Date(a.Fecha))[0];
      setRowSelected(latest.IdDocumento);

      //Seleccionamos la tab que tenga documentos
      if (listaDocs.length > 0) {
        setTabSelected("estudio");
      } else if (listaDocsPatient.length > 0) {
        setTabSelected("paciente");
      }
      const name = latest.Nombre?.toLowerCase() || "";
      const fileType = name.split(".").pop();
      // const isPdf = name.endsWith(".pdf");
      // const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/.test(name);
      setFileType(fileType);
    }
  }, [listaDocs, listaDocsPatient, rowSelected, doc]);

  useEffect(() => {
    if (!rowSelected) return;
    setDoc({ url: null, isPdf: false });
    setZoom(1);
    setPos({ x: 0, y: 0 });
    AppManager.loadStudyDocumentoByid(prompt, rowSelected, selectedUrl, fileType);
  }, [rowSelected, selectedUrl, AppManager, fileType]);

  const resetState = () => {
    setRowSelected(null);
    setListaDocs([]);
    setListaDocsPatient([]);
    setDoc({ url: null, isPdf: false });
    setZoom(1);
    setPos({ x: 0, y: 0 });
  };

  const currentDocs = tabSelected === "estudio" ? listaDocs : listaDocsPatient;

  useLayoutEffect(() => {
    if (!open) return;

    // esperar a que MUI pinte el Dialog/Tabs
    requestAnimationFrame(() => {
      AppManager.translator.changeLabelsTitle();
    });
  }, [open, tabSelected, AppManager.translator, AppManager.isLoadingDocumentos]);

  const actualTranslate=translate.find(t => t.language === AppManager.translator.current_lang) || translate[0];
  return (
    <>
      <MobileView>
        <Dialog
          open={open}
          onClose={() => {
            closeModal();
            resetState();
          }}
          fullScreen
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" p={2} borderBottom="1px solid #ccc">
            <Typography variant="h6">
              {" "}
              <span data-language_txt="txt_Documents">{actualTranslate.labels.txt_Documents}</span>
            </Typography>
            <button className="btn-close" onClick={closeModal} />
          </Box>

          <Tabs value={tabSelected} onChange={(_, val) => setTabSelected(val)} variant="fullWidth">
            <Tab
              value="estudio"
              label={
                <span>
                  <span data-language_txt="txt_Estudio">{actualTranslate.labels.txt_Estudio}</span>
                  {` (${listaDocs.length})`}
                </span>
              }
            />

            <Tab
              value="paciente"
              label={
                <span>
                  <span data-language_txt="lbl_Paciente">{actualTranslate.labels.lbl_Paciente}</span>
                  {` (${listaDocsPatient.length})`}
                </span>
              }
            />
          </Tabs>

          <DialogContent sx={{ p: 0 }}>
            <Stack spacing={1} p={1}>
              {(tabSelected === "estudio" ? listaDocs : listaDocsPatient).map((docItem) => {
                let name = docItem.Nombre?.toLowerCase() || "";
                const isPdf = name.endsWith(".pdf");
                const isImagen = name.endsWith(".png") || name.endsWith(".jpg") || name.endsWith(".jpeg");
                const splited = name.split(".");
                const fileType = splited.pop();
                name = splited[0];
                return (
                  <Box
                    key={docItem.IdDocumento}
                    onClick={() => {
                      setRowSelected(docItem.IdDocumento);
                      setFileType(fileType);
                    }}
                    p={2}
                    bgcolor="#fff"
                    borderBottom="1px solid #ddd"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box display={"flex"} flexDirection="column" justifyContent="center" width="100%">
                      <Typography
                        variant="subtitle2"
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: 250,
                          display: "inline-block",
                          textTransform: "uppercase",
                        }}
                      >
                        {name}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {docItem.Fecha ? new Date(docItem.Fecha).toLocaleDateString("es-ES") : "Sin Fecha"}
                      </Typography>
                    </Box>
                    <Box display={"flex"} flexDirection="column" justifyContent="center" alignItems="center">
                      {isPdf ? (
                        <PictureAsPdf fontSize="small" color="error" />
                      ) : isImagen ? (
                        <Image fontSize="small" color="primary" />
                      ) : (
                        <InsertDriveFileIcon fontSize="small" color="primary" />
                      )}
                      <Typography variant="caption" color="#C4C0C0FF">
                        {fileType}
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </Stack>
          </DialogContent>
        </Dialog>

        {/* Visor separado */}
        <Dialog open={!!rowSelected && !!doc.url} onClose={() => setRowSelected(null)} fullScreen>
          <Box display="flex" justifyContent="space-between" alignItems="center" p={2} borderBottom="1px solid #ccc">
            <Typography variant="h6">Visor</Typography>
            <button className="btn-close" onClick={() => setRowSelected(null)} />
          </Box>
          <DialogContent sx={{ p: 0 }}>
            {doc.isPdf ? (
              <Box p={2} display="flex" flexDirection="column" alignItems="center">
                {loadingPdf && <CircularProgress />}
                {errorPdf && <Typography color="error">{actualTranslate.labels.error_loading_document}</Typography>}
                <Document
                  file={doc.url}
                  onLoadSuccess={({ numPages }) => {
                    setTotalPages(numPages);
                    setLoadingPdf(false);
                  }}
                  onLoadError={() => {
                    setLoadingPdf(false);
                    setErrorPdf(true);
                  }}
                  loading={() => {
                    setLoadingPdf(true);
                    return null;
                  }}
                >
                  {[...Array(totalPages)].map((_, idx) => (
                    <Page key={idx + 1} pageNumber={idx + 1} width={window.innerWidth - 40} />
                  ))}
                </Document>
              </Box>
            ) : doc.isImage ? (
              <>
                <Box
                  sx={{ overflow: "hidden", touchAction: "none", height: "calc(100vh - 80px)" }}
                  onTouchStart={startDrag}
                  onTouchMove={duringDrag}
                  onTouchEnd={endDrag}
                >
                  <img
                    src={doc.url}
                    alt="Documento"
                    style={{
                      transform: `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`,
                      transformOrigin: "top left",
                      maxWidth: "100%",
                      userSelect: "none",
                      touchAction: "none",
                    }}
                    draggable={false}
                  />
                </Box>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                  mt={1}
                  sx={{ position: "absolute", bottom: 16, left: "50%", transform: "translateX(-50%)" }}
                >
                  <IconButton size="small" onClick={() => setZoom((z) => Math.max(z - 0.1, 0.5))}>
                    <ZoomOut />
                  </IconButton>
                  <Slider size="small" min={0.5} max={2} step={0.1} value={zoom} onChange={(_, v) => setZoom(v)} sx={{ width: 100 }} />
                  <IconButton size="small" onClick={() => setZoom((z) => Math.min(z + 0.1, 2))}>
                    <ZoomIn />
                  </IconButton>
                </Stack>
              </>
            ) : (
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
                <Typography variant="body1" color="textSecondary" mb={2} textAlign={"center"} p={2}>
                  {actualTranslate.labels.txt_noPreview_mobile}
                </Typography>
                <Button variant="contained" color="primary" href={doc.url} download={doc.name} onClick={() => setRowSelected(null)}>
                  {actualTranslate.labels.descargar}
                </Button>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </MobileView>
      <BrowserView>
        <Dialog
          open={open}
          onClose={() => {
            closeModal();
            resetState();
          }}
          fullWidth
          maxWidth="xl"
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" pr={2} sx={{ borderBottom: "1px solid #ccc" }}>
            <DialogTitle>
              {" "}
              <span data-language_txt="txt_DocumentsList">Documents List</span>
            </DialogTitle>
            <button
              className="btn-close btn btn-sm btn-circle d-flex flex-center transition-base"
              aria-label="Close"
              onClick={closeModal}
            />
          </Box>
          <DialogContent sx={{}}>
            {AppManager.isLoadingDocumentos || AppManager.isLoadingDocumentosPatient || AppManager.isLoadingDocumentoPDF ? (
              <Box display="flex" justifyContent="center" alignItems="center" height="500px">
                <CircularProgress />
              </Box>
            ) : (
              <Box display="flex" height="70vh" borderRadius={2} overflow="hidden">
                <Box width="40%" borderRight="1px solid #ddd" overflow="auto" pr={2} bgcolor="#fff" boxShadow={1}>
                  <Tabs
                    value={tabSelected}
                    onChange={(_, val) => setTabSelected(val)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ ".MuiTabs-flexContainer": { gap: 1, p: 1, pb: 3, color: "black" } }}
                    TabIndicatorProps={{ style: { display: "none" } }}
                  >
                    <Tab
                      value="estudio"
                      label={
                        <span>
                          <span data-language_txt="txt_Estudio">{actualTranslate.labels.txt_Estudio}</span>
                          {` (${listaDocs.length})`}
                        </span>
                      }
                      sx={{
                        borderRadius: 20,
                        border: "1px solid #ccc",
                        textTransform: "none",
                        px: 2,
                        bgcolor: tabSelected === "estudio" ? "#e3f2fd" : "#fff",
                      }}
                    />
                    <Tab
                      value="paciente"
                      label={
                        <span>
                          <span data-language_txt="lbl_Paciente">{actualTranslate.labels.lbl_Paciente}</span>
                          {` (${listaDocsPatient.length})`}
                        </span>
                      }
                      sx={{
                        borderRadius: 20,
                        border: "1px solid #ccc",
                        textTransform: "none",
                        px: 2,
                        bgcolor: tabSelected === "paciente" ? "#e3f2fd" : "#fff",
                      }}
                    />
                  </Tabs>
                  <Stack spacing={1} mt={1}>
                    {currentDocs.length ? (
                      currentDocs.map((d, i) => (
                        <Box
                          key={i}
                          p={2}
                          bgcolor={rowSelected === d.IdDocumento ? "#d1e7fd" : "#fff"}
                          sx={{
                            borderLeft: "6px solid red",
                            cursor: "pointer",
                            borderRadius: 1,
                            mx: 1,
                            boxShadow: rowSelected === d.IdDocumento ? 1 : 0,
                            "&:hover": { bgcolor: "#f0f0f0" },
                          }}
                          onClick={() => {
                            setRowSelected(d.IdDocumento);

                            const name = d.Nombre?.toLowerCase() || "";
                          
                            const fileType = name.split(".").pop();
                            setFileType(fileType);
                          }}
                        >
                          <Typography variant="subtitle1" fontWeight={600} noWrap>
                            {d.Nombre}
                          </Typography>

                          <Box display="flex" justifyContent="space-between" mt={0}>
                            <Typography variant="body2" color="textSecondary">
                              {d.Procedencia || "Sin Procedencia"}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              {d.Fecha ? new Date(d.Fecha).toLocaleDateString("es-ES") : "Sin Fecha"}
                            </Typography>
                          </Box>
                          <Box display="flex" alignItems="center" gap={1} mt={1}>
                            {(() => {
                              const name = d.Nombre?.toLowerCase() || "";
                              const isPdf = name.endsWith(".pdf");
                              const isImagen = name.endsWith(".png") || name.endsWith(".jpg") || name.endsWith(".jpeg");
                              return (
                                <>
                                  {isPdf ? (
                                    <>
                                      <PictureAsPdf fontSize="small" color="error" />
                                      <Typography variant="caption" color="textSecondary">
                                        {actualTranslate.labels.tipo_pdf}
                                      </Typography>
                                    </>
                                  ) : isImagen ? (
                                    <>
                                      <Image fontSize="small" color="primary" />
                                      <Typography variant="caption" color="textSecondary">
                                        {actualTranslate.labels.tipo_imagen}
                                      </Typography>
                                    </>
                                  ) : (
                                    <>
                                      <InsertDriveFileIcon fontSize="small" color="primary" />
                                      <Typography variant="caption" color="textSecondary">
                                        {actualTranslate.labels.tipo_archivo}
                                      </Typography>
                                    </>
                                  )}
                                </>
                              );
                            })()}
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Box pt={6} bgcolor="#fff" display="flex" justifyContent="center" alignItems="center">
                        <Typography variant="body2" color="textSecondary" data-language_txt="lbl_NoDocumento">
                          {actualTranslate.labels.txt_noDocuments}
                        </Typography>
                      </Box>
                    )}
                  </Stack>
                </Box>
                <Box
                  width="60%"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  position="relative"
                  bgcolor="#fdfdfd"
                  boxShadow={1}
                >
                  {rowSelected ? (
                    doc.url ? (
                      doc.isPdf ? (
                        <object data={doc.url} type="application/pdf" width="100%" height="100%" aria-label="pdf"/>
                      ) : doc.isImage ? (
                        <Box width="100%" height="100%" display="flex" flexDirection="column" alignItems="center">
                          <Box
                            sx={{ width: "100%", height: "100%", overflow: "hidden", position: "relative" }}
                            onMouseMove={duringDrag}
                            onMouseUp={endDrag}
                            onMouseLeave={endDrag}
                            onTouchMove={duringDrag}
                            onTouchEnd={endDrag}
                          >
                            <img
                              src={doc.url}
                              alt={actualTranslate.labels.documento}
                              style={{
                                transform: `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`,
                                transformOrigin: "top left",
                                cursor: dragging ? "grabbing" : "grab",
                                maxWidth: "100%",
                                maxHeight: "100%",
                                userSelect: "none",
                              }}
                              draggable={false}
                              onMouseDown={startDrag}
                              onTouchStart={startDrag}
                            />
                          </Box>
                          <Box display="flex" alignItems="center" gap={1} mt={1}>
                            <IconButton size="small" onClick={() => setZoom((z) => Math.max(z - 0.1, 0.5))}>
                              <ZoomOut />
                            </IconButton>
                            <Slider
                              size="small"
                              min={0.5}
                              max={2}
                              step={0.1}
                              value={zoom}
                              onChange={(_, v) => setZoom(v)}
                              sx={{ width: 120 }}
                            />
                            <IconButton size="small" onClick={() => setZoom((z) => Math.min(z + 0.1, 2))}>
                              <ZoomIn />
                            </IconButton>
                            <Typography variant="body2">{Math.round(zoom * 100)} %</Typography>
                          </Box>
                          <Tooltip title={actualTranslate.labels.imprimir}>
                            <span>
                              <IconButton
                                sx={{ position: "absolute", bottom: 24, right: 24, bgcolor: "#dddd" }}
                                onClick={handlePrint}
                                disabled={!doc.url}
                              >
                                <Print />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </Box>
                      ) : (
                        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" height="100%">
                          <Typography variant="body1" color="textSecondary" mb={2}>
                            {actualTranslate.labels.txt_noPreview}
                          </Typography>
                          <Button variant="contained" color="primary" href={doc.url} download={doc.name} target="_blank">
                            {actualTranslate.labels.descargar}
                          </Button>
                        </Box>
                      )
                    ) : (
                      <Typography variant="h6" color="textSecondary">
                        {actualTranslate.labels.cargando}
                      </Typography>
                    )
                  ) : (
                    <Typography variant="h6" color="textSecondary">
                      {actualTranslate.labels.txt_selectDocument}
                    </Typography>
                  )}
                </Box>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </BrowserView>
    </>
  );
}
